var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.394775H16.5C17.5938 0.394775 18.5 1.30103 18.5 2.39478V3.39478H0.5V2.39478C0.5 1.30103 1.375 0.394775 2.5 0.394775ZM18.5 6.39478V12.3948C18.5 13.5198 17.5938 14.3948 16.5 14.3948H2.5C1.375 14.3948 0.5 13.5198 0.5 12.3948V6.39478H18.5ZM4 10.3948C3.71875 10.3948 3.5 10.6448 3.5 10.8948C3.5 11.176 3.71875 11.3948 4 11.3948H6C6.25 11.3948 6.5 11.176 6.5 10.8948C6.5 10.6448 6.25 10.3948 6 10.3948H4ZM7.5 10.8948C7.5 11.176 7.71875 11.3948 8 11.3948H12C12.25 11.3948 12.5 11.176 12.5 10.8948C12.5 10.6448 12.25 10.3948 12 10.3948H8C7.71875 10.3948 7.5 10.6448 7.5 10.8948Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.4925500105d7620a819d37a3f797df5b.svg";
export { ForwardRef as ReactComponent };